import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {timeFormat} from 'd3-time-format'
import {Modal, Alert} from 'antd'

@inject('store') @observer
class FrozenModal extends Component {
  unsubscribe = async () => {
    await this.props.store.subscription.unsubscribe()
    this.props.handleCancel()
  }

  render() {
    const {visible} = this.props
    const {loading} = this.props.store.subscription
    const {frozen_date: frozenDate, frozen_due: frozenDue} = this.props.store.user.data.account
    return(
      <Modal
        visible={visible}
        onOk={this.props.handleOk}
        onCancel={this.props.handleCancel}
        okText='Update payment method'
        cancelText='Close'
        confirmLoading={loading}
      >
        <Alert
          description={
            <p>
              Your account is on hold because we were not able to process your payment on {' '}
              <b>{timeFormat('%b %d %Y')(new Date(frozenDate))}</b>. Please update your payment method by {' '}
              <b>{timeFormat('%b %d %Y')(new Date(frozenDue))}</b> to avoid losing your saved Algorithms. If you have any questions, please email support@algoriz.com
            </p>
          }
          type='warning'
          showIcon
        />
      </Modal>
    )
  }
}

export default FrozenModal
